import React from "react";
import "./GetMobileNumber.css";

export default function HappyFamily() {
  return (
    <div className="icon-text-containers">
      <div className="icon-container">
        <svg
          width="41"
          height="40"
          viewBox="0 0 41 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.5651 33.036C10.1328 36.0617 9.51535 39.0875 8.9596 39.0257C8.15686 38.964 7.84811 36.0617 7.72461 32.4803M13.5291 39.1492C13.4056 39.3962 13.2821 39.5197 13.0968 39.5197C12.4176 39.5197 11.9236 36.3087 11.6766 33.1595M21.68 15.6844V18.7101M22.668 38.5935C22.8533 39.1492 23.1003 39.5197 23.3473 39.5197C24.9527 39.5197 25.5085 26.367 25.5702 24.3911V24.1441V24.3293C25.7555 26.1818 27.114 39.0257 28.4725 38.9022C31.0659 38.6552 29.7075 13.0291 29.7075 12.7821C29.7075 12.7821 38.9081 3.02571 37.4262 1.42022C36.0677 -0.123517 29.3987 8.08918 24.891 9.75641C23.8412 10.1269 22.3593 10.3122 20.7538 10.3122M21.0625 13.8936H20.6303"
            stroke="#179D82"
            stroke-width="0.926244"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M24.0882 7.40982C25.7934 7.40982 27.1757 6.02751 27.1757 4.32234C27.1757 2.61717 25.7934 1.23486 24.0882 1.23486C22.383 1.23486 21.0007 2.61717 21.0007 4.32234C21.0007 6.02751 22.383 7.40982 24.0882 7.40982Z"
            stroke="#179D82"
            stroke-width="0.926244"
            stroke-miterlimit="10"
          />
          <path
            d="M12.8499 31.3687C8.83615 31.1834 3.89618 29.7632 4.14318 27.9107C4.14318 27.9107 8.8979 17.2898 8.83615 13.523C8.7744 10.7443 5.13118 2.96386 7.23066 2.53161C9.2684 2.16111 10.9974 11.1765 13.4674 12.8438C14.7024 13.7083 17.6663 13.77 20.3216 13.8318H21.6801"
            stroke="#179D82"
            stroke-width="0.926244"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.9991 22.9706C13.4673 21.8591 9.88587 18.7099 8.89788 20.3154C7.66289 22.1679 15.0728 26.8608 15.0728 26.8608M25.632 24.3291V24.1438C25.632 24.1438 25.5703 24.2056 25.632 24.3291Z"
            stroke="#179D82"
            stroke-width="0.926244"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M18.0368 32.6034C18.0368 32.6034 18.6543 39.5193 20.0128 39.5193C22.0505 39.5193 21.6183 25.5022 21.6183 25.5022C21.6183 25.5022 27.361 20.8092 26.126 19.3272C24.644 17.4747 19.8893 23.2174 17.4811 23.3409C15.1963 23.4644 10.1329 18.3392 8.83611 20.3152C7.60112 22.1677 15.0111 26.8607 15.0111 26.8607C15.0111 26.8607 13.6526 39.5193 16.3078 39.5193C18.0368 39.5193 18.0368 32.6034 18.0368 32.6034Z"
            stroke="#179D82"
            stroke-width="0.926244"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M17.543 21.3034C18.8049 21.3034 19.8278 20.2804 19.8278 19.0186C19.8278 17.7568 18.8049 16.7339 17.543 16.7339C16.2812 16.7339 15.2583 17.7568 15.2583 19.0186C15.2583 20.2804 16.2812 21.3034 17.543 21.3034Z"
            stroke="#179D82"
            stroke-width="0.926244"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M16.3695 11.362C18.0746 11.362 19.4569 9.97966 19.4569 8.27449C19.4569 6.56932 18.0746 5.18701 16.3695 5.18701C14.6643 5.18701 13.282 6.56932 13.282 8.27449C13.282 9.97966 14.6643 11.362 16.3695 11.362Z"
            stroke="#179D82"
            stroke-width="0.926244"
            stroke-miterlimit="10"
          />
        </svg>
        <div>
          <p className="icon-text">
            20,000+ <br />
            Happy Families
          </p>
        </div>
      </div>{" "}
      <div className="icon-container">
        <svg
          width="31"
          height="30"
          viewBox="0 0 31 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_115_803)">
            <path
              d="M30.4637 16.7236C30.242 15.1877 29.0355 13.9812 27.4996 13.7595V12.8505C27.4996 10.3425 25.5931 8.30056 23.2497 8.30056C20.9737 8.30056 19.0682 10.2805 18.9997 12.7145H19.0287L18.9997 12.7195V22.5729C18.9997 25.7228 16.6448 28.2808 13.7498 28.2808C10.8548 28.2808 8.49988 25.7193 8.49988 22.5729V21.7194C9.22487 21.7194 9.99986 21.1939 9.99986 19.7194V18.4619C13.2088 17.6414 15.4998 14.886 15.4998 11.762V10.7195H14.4998L14.4788 4.21212C14.4715 3.00758 13.6072 1.97909 12.4218 1.76466C12.1661 0.981356 11.3238 0.553613 10.5405 0.809359C9.75718 1.06504 9.32943 1.90734 9.58518 2.69071C9.84086 3.47401 10.6832 3.90175 11.4665 3.64601C11.6737 3.57836 11.8636 3.46614 12.0227 3.31724C12.1819 3.16834 12.3065 2.98637 12.3878 2.78414C12.6997 2.87287 12.9744 3.06026 13.1708 3.31823C13.3672 3.57621 13.4748 3.89089 13.4773 4.21512L13.4998 10.7195H12.4998V11.7765C12.4599 13.5157 11.294 15.027 9.62187 15.507C8.72719 15.7908 7.76658 15.7908 6.87191 15.507C5.20174 15.0254 4.03839 13.5143 3.99995 11.7765V10.7195H2.49997V4.21962C2.50138 3.89084 2.61077 3.57162 2.81132 3.31109C3.01187 3.05055 3.29247 2.86312 3.60995 2.77764C3.91426 3.55232 4.78894 3.93356 5.56361 3.62926C6.33829 3.32495 6.71953 2.45021 6.41523 1.6756C6.11092 0.900982 5.23618 0.519676 4.46157 0.823984C4.25427 0.905428 4.0676 1.03181 3.91498 1.19403C3.76237 1.35625 3.64761 1.55028 3.57895 1.76216C2.38066 1.9669 1.5033 3.00395 1.49999 4.21962V10.7195H0.5V11.7595C0.5 14.887 2.79247 17.6434 5.99992 18.4619V19.7194C5.99992 21.1939 6.77491 21.7194 7.4999 21.7194V22.5729C7.4999 26.2728 10.3034 29.2808 13.7498 29.2808C17.1963 29.2808 19.9997 26.2693 19.9997 22.5729V12.7435C20.0497 10.846 21.5087 9.30205 23.2497 9.30205C25.0416 9.30205 26.4996 10.894 26.4996 12.852V13.7595C24.5865 14.0356 23.2594 15.8104 23.5355 17.7235C23.8117 19.6367 25.5864 20.9638 27.4996 20.6876C29.4128 20.4115 30.7398 18.6367 30.4637 16.7236ZM10.9998 2.71964C10.8672 2.71964 10.7401 2.66697 10.6463 2.5732C10.5525 2.47943 10.4999 2.35226 10.4999 2.21965C10.4999 2.08704 10.5525 1.95987 10.6463 1.8661C10.7401 1.77234 10.8672 1.71966 10.9998 1.71966C11.1325 1.71966 11.2596 1.77234 11.3534 1.8661C11.4472 1.95987 11.4998 2.08704 11.4998 2.21965C11.4998 2.35226 11.4472 2.47943 11.3534 2.5732C11.2596 2.66697 11.1325 2.71964 10.9998 2.71964ZM4.99993 1.71966C5.13254 1.71966 5.25972 1.77234 5.35348 1.8661C5.44725 1.95987 5.49993 2.08704 5.49993 2.21965C5.49993 2.35226 5.44725 2.47943 5.35348 2.5732C5.25972 2.66697 5.13254 2.71964 4.99993 2.71964C4.86733 2.71964 4.74015 2.66697 4.64639 2.5732C4.55262 2.47943 4.49994 2.35226 4.49994 2.21965C4.49994 2.08704 4.55262 1.95987 4.64639 1.8661C4.74015 1.77234 4.86733 1.71966 4.99993 1.71966ZM1.49999 11.7595V11.7195H2.99996V11.7765C3.03746 13.9497 4.48325 15.8462 6.56891 16.4579C7.66182 16.804 8.83495 16.804 9.92786 16.4579C12.0145 15.847 13.4616 13.9504 13.4998 11.7765V11.7195H14.4998V11.7595C14.4998 14.541 12.3558 16.9884 9.39987 17.5804C8.70575 17.7194 7.9948 17.7543 7.2904 17.6839C7.05854 17.6614 6.82805 17.6265 6.59991 17.5794C3.64395 16.9884 1.49999 14.541 1.49999 11.7595ZM7.4999 20.7194C7.0499 20.7194 6.9999 20.0194 6.9999 19.7194V18.6584C7.0399 18.6634 7.0809 18.6654 7.1214 18.6694C7.1714 18.6749 7.2214 18.6789 7.2714 18.6834C7.5079 18.7044 7.74639 18.7184 7.98689 18.7189H8.01189C8.25189 18.7189 8.48988 18.7044 8.72488 18.6834C8.77488 18.6789 8.82788 18.6749 8.87938 18.6694C8.91888 18.6649 8.95988 18.6634 8.99938 18.6584V19.7194C8.99938 20.0194 8.94938 20.7194 8.49938 20.7194H7.4999ZM26.9996 19.7194C25.6189 19.7194 24.4996 18.6001 24.4996 17.2194C24.4996 15.8388 25.6189 14.7195 26.9996 14.7195C28.3803 14.7195 29.4996 15.8388 29.4996 17.2194C29.4979 18.5995 28.3796 19.7178 26.9996 19.7194Z"
              fill="#179D82"
            />
            <path
              d="M26.9995 15.7197C26.1711 15.7197 25.4995 16.3913 25.4995 17.2197C25.4995 18.0481 26.1711 18.7197 26.9995 18.7197C27.8279 18.7197 28.4995 18.0481 28.4995 17.2197C28.4995 16.3913 27.8279 15.7197 26.9995 15.7197ZM26.9995 17.7197C26.8669 17.7197 26.7397 17.667 26.6459 17.5733C26.5522 17.4795 26.4995 17.3523 26.4995 17.2197C26.4995 17.0871 26.5522 16.9599 26.6459 16.8662C26.7397 16.7724 26.8669 16.7197 26.9995 16.7197C27.1321 16.7197 27.2593 16.7724 27.353 16.8662C27.4468 16.9599 27.4995 17.0871 27.4995 17.2197C27.4995 17.3523 27.4468 17.4795 27.353 17.5733C27.2593 17.667 27.1321 17.7197 26.9995 17.7197Z"
              fill="#179D82"
            />
          </g>
          <defs>
            <clipPath id="clip0_115_803">
              <rect
                width="30"
                height="30"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>

        <div>
          <p className="icon-text">
            50+ Doctors
            <br />
            <span className="span-element">Trusted Care</span>
          </p>
        </div>
      </div>
    </div>
  );
}
